module.exports = __webpack_public_path__ + "static/img/6-2.47cedd54.jpg";